import React from 'react';

/** Selected Diagonal Lift dumbbell, preserving the approved 24px sketch geometry. */
export default function DiagonalDumbbellIcon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <g transform="rotate(-35 12 12)">
      <path d="M7.8 12h8.4" />
      <path d="M4.1 8.5h2.2a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H4.1a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1Zm13.6 0h2.2a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-2.2a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1Z" />
      <path d="M2 10v4M22 10v4" />
    </g>
  </svg>;
}
